import axios from '@/user/axios.js'

const moduleSlideReport = {
  namespaced: true,
  state: {
    periods: {},
    filters: {}
  },
  mutations: {
    SET_PERIOD_DATA (state, data) {
      state.periods = data
    },
    SET_FILTER_DATA (state, data) {
      state.filters = data
    }
  },
  actions: {
    fetchPeriods (context, payload) {
      return new Promise(async (resolve, reject) => {
        const sellerId = context.rootState.account.activeAccount.sellerId
        try {
          const res = await axios.get(`/api/slide-report/${sellerId}/periods`, {
            params: payload
          })
          if (res.data.success) {
            context.commit('SET_PERIOD_DATA', res.data.data)
          }
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    fetchFilters (context, payload) {
      return new Promise(async (resolve, reject) => {
        const sellerId = context.rootState.account.activeAccount.sellerId
        try {
          const res = await axios.get(`/api/slide-report/${sellerId}/filters`, {
            params: payload
          })
          if (res.data.success) {
            context.commit('SET_FILTER_DATA', res.data.data)
          }
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    addSlideReport (context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.post(`/api/slide-report/${sellerId}`, payload)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    }
  }
}

export default moduleSlideReport
